/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedblockautomaticmoveupdaysinadvance7Inputs */

const en__field_inheritedblockautomaticmoveupdaysinadvance7 = /** @type {(inputs: _Field_Inheritedblockautomaticmoveupdaysinadvance7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auto waiting list update period (inherited)`)
};

const de__field_inheritedblockautomaticmoveupdaysinadvance7 = /** @type {(inputs: _Field_Inheritedblockautomaticmoveupdaysinadvance7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Wartenlisten Update Frist (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "auto waiting list update period (inherited)" |
*
* @param {_Field_Inheritedblockautomaticmoveupdaysinadvance7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedblockautomaticmoveupdaysinadvance7 = /** @type {((inputs?: _Field_Inheritedblockautomaticmoveupdaysinadvance7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedblockautomaticmoveupdaysinadvance7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedblockautomaticmoveupdaysinadvance7(inputs)
	return de__field_inheritedblockautomaticmoveupdaysinadvance7(inputs)
});
export { _field_inheritedblockautomaticmoveupdaysinadvance7 as "_field_inheritedBlockAutomaticMoveUpDaysInAdvance" }